import Vue from "vue";
import Router from "vue-router";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: () => import("./views/home"),
      meta: { authRequired: true },
    },
    {
      path: "/login",
      component: () => import("./views/login"),
      meta: { authRequired: false },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login-in"),
      meta: { authRequired: false },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/register",
      component: () => import("./views/register"),
      meta: { authRequired: false },
    },
    {
      path: "/register/:sponsor",
      component: () => import("./views/register"),
      meta: { authRequired: false },
    },
    {
      path: "/password-forgot",
      component: () => import("./views/password-forgot"),
      meta: { authRequired: false },
    },
    {
      path: "/password-change",
      component: () => import("./views/password-change"),
      meta: { authRequired: false },
    },
    {
      path: "/account",
      component: () => import("./views/account/account"),
      meta: { authRequired: true },
    },
    {
      path: "/account/documents",
      component: () => import("./views/account/documents"),
      meta: { authRequired: true },
    },
    {
      path: "/account/address",
      component: () => import("./views/account/address"),
      meta: { authRequired: true },
    },
    {
      path: "/account/password",
      component: () => import("./views/account/password"),
      meta: { authRequired: true },
    },
    {
      path: "/account/password/security",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true },
    },
    {
      path: "/account/password/security/:token",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true },
    },
    {
      path: "/account/pix",
      component: () => import("./views/account/pix"),
      meta: { authRequired: true },
    },
    {
      path: "/downloads",
      component: () => import("./views/downloads"),
      meta: { authRequired: true },
    },
    {
      path: "/faq",
      component: () => import("./views/faq"),
      meta: { authRequired: true },
    },
    {
      path: "/tickets",
      component: () => import("./views/tickets"),
      meta: { authRequired: true },
    },
    {
      path: "/tickets/:id",
      component: () => import("./views/tickets-view"),
      meta: { authRequired: true },
    },
    {
      path: "/informatives",
      component: () => import("./views/informatives/index"),
      meta: { authRequired: true },
    },
    {
      path: "/informatives/:id",
      component: () => import("./views/informatives/view"),
      meta: { authRequired: true },
    },
    {
      path: "/events",
      component: () => import("./views/events/index"),
      meta: { authRequired: true },
    },
    {
      path: "/events/:id",
      component: () => import("./views/events/view"),
      meta: { authRequired: true },
    },
    {
      path: "/planos",
      component: () => import("./views/_planos/index"),
      meta: { authRequired: true },
    },
    {
      path: "/dependentes",
      component: () => import("./views/_dependentes/index"),
      meta: { authRequired: true },
    },
    {
      path: "/pagamentos/faturas",
      component: () => import("./views/_pagamentos/faturas"),
      meta: { authRequired: true },
    },
    {
      path: "/pagamentos/cartoes",
      component: () => import("./views/_pagamentos/cartoes"),
      meta: { authRequired: true },
    },
    {
      path: "/telemedicina",
      component: () => import("./views/_telemedicina/index"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/plantao",
      component: () => import("./views/_telemedicina/plantao"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/historico",
      component: () => import("./views/_telemedicina/historico"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/plantao/:id",
      component: () => import("./views/_telemedicina/plantao-view"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/agendamento",
      component: () => import("./views/_telemedicina/agendamento"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/consultas",
      component: () => import("./views/_telemedicina/consultas"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/consultas/publico",
      component: () => import("./views/_telemedicina/consultas-publico"),
      meta: { authRequired: false },
    },
    {
      path: "/telemedicina/exames/publico",
      component: () => import("./views/_telemedicina/exames-publico"),
      meta: { authRequired: false },
    },
    {
      path: "/telemedicina/exames",
      component: () => import("./views/_telemedicina/exames"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/agendamentos",
      component: () => import("./views/_telemedicina/agendamentos"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/agendamentos/:id",
      component: () => import("./views/_telemedicina/agendamentos-view"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/medicamentos",
      component: () => import("./views/_telemedicina/medicamentos"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/carteirinha",
      component: () => import("./views/_telemedicina/carteirinha"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/telemedicina/prontuario",
      component: () => import("./views/_telemedicina/prontuario"),
      meta: { authRequired: true, service: 'telemedicina' },
    },
    {
      path: "/descontos",
      component: () => import("./views/_descontos/index"),
      meta: { authRequired: true, service: 'descontos' },
    },
    {
      path: "/descontos/:id",
      component: () => import("./views/_descontos/view"),
      meta: { authRequired: true, service: 'descontos' },
    },
    {
      path: "/app",
      component: () => import("./views/_app/index"),
      meta: { authRequired: false },
    },
    {
      path: "/:sponsor",
      redirect: "/register/:sponsor",
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: { authRequired: false },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  document.title = process.env.VUE_APP_TITLE;
  next();

  if (to.meta.authRequired && !loggedIn) {
    next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == 'success') {
          if (response.data.user) {
            router.app.$store.state.account.user = response.data.user;

            // Faturas é exclusivo do titular
            if (to.path == '/pagamentos/faturas' && response.data.user.plan && response.data.user.plan.client && response.data.user.plan.client.role != 'holder') {
              return next("/");
            }

            if (response.data.user.plan && response.data.user.plan.current) {
              if (response.data.user.plan.client.status == 'active') {
                if (to.path != '/telemedicina' && to.meta.service == 'telemedicina' && response.data.user.plan.current.service.telemedicina == 'inactive') {
                  return next("/planos");
                } else if (to.path != '/descontos' && to.meta.service == 'descontos' && response.data.user.plan.current.service.descontos == 'inactive') {
                  return next("/planos");
                }
              } else {
                if (to.path != '/telemedicina' && to.meta.service == 'telemedicina') {
                  return next("/planos");
                } else if (to.path != '/descontos' && to.meta.service == 'descontos') {
                  return next("/planos");
                }
              }
            }
          }

          next();
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  } else {
    next();
  }
});

export default router;
